import { Component, inject, linkedSignal } from '@angular/core';
import { SnackService } from 'src/app/core/services/snack.service';
import { first } from 'rxjs';
import { DialogRef } from '@app/core/services/dialog-ref';
import { EmployeeDataService } from '@app/core/services/employee-data.service';
import { VisibilitySettingsComponent } from '@app/features/visibility-settings/visibility-settings.component';

@Component({
  selector: 'if-visibility-settings-notification-dialog',
  templateUrl: './visibility-settings-notification-dialog.component.html',
  imports: [VisibilitySettingsComponent],
})
export class VisibilitySettingsNotificationDialogComponent {
  protected readonly selectedVisibilityGroups = linkedSignal(() => this.employeeDataService.employee()?.visibilityGroups ?? []);
  private readonly employeeDataService = inject(EmployeeDataService);
  private readonly snackService = inject(SnackService);
  private readonly dialogRef = inject(DialogRef);

  onConfirmButtonClick() {
    this.employeeDataService.updateVisibilityGroups(this.selectedVisibilityGroups()).pipe(first()).subscribe();
    this.snackService.destroySnack();
    this.dialogRef.close(false);
  }

  onCancelButtonClick() {
    this.dialogRef.close(false);
  }
}
